import React, { useState } from 'react';
import Modal from '../Modal';

import { Box, Img, NoButton, Text, Title, WrapButton, YesButton } from './ReturnModal.styled';

import Image from '../../../images/return.png'
import { useReturnOrderMutation } from '../../../redux/orders/ordersApi';
import { showErrorToast, showSuccessToast } from 'utils/showToast';
import { useConfirmDishReturnMutation } from '../../../redux/dishorders/dishordersApi';



const ReturnModal = ({ onClose, orderId,type }) => {
  const [returnOrder] = useReturnOrderMutation();
    const [confirmDishReturn] = useConfirmDishReturnMutation();
console.log('orderIdrey :>> ', orderId);
  const handleReturn = async () => {
    try {
      if (type === 'dish') {
        const data = await confirmDishReturn(orderId)
      } else if (type === 'bag') {
         const data = await returnOrder(orderId)

      }

      showSuccessToast('Товар повернено')
      onClose();
  
  } catch (error) {
    showErrorToast('Помилка повернення')
    onClose();
  }
}


  return (
    <Modal onClose={onClose}>
      <Box>
        <Img src={Image} alt="Вихід" />
        <Title>Повернення товару</Title>
        <Text>Якщо клієнт повернув товар, натисніть кнопку «Товар повернено» для підтвердження.</Text>
        <WrapButton>
          <NoButton onClick={onClose}>Скасувати</NoButton>
          <YesButton
            onClick={handleReturn}>Товар повернено</YesButton>

        </WrapButton>
      </Box>

    </Modal>
  );
};

export default ReturnModal;
